import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { makeStyles } from "@mui/styles";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
// import { DataGrid } from '@mui/x-data-grid';
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Button,
  Grid,
} from "@mui/material";

//import { getInitials } from 'helpers';
import { useHistory } from "react-router-dom";
import { setTransactionDetail, setTransactionPage, setTransactionIds } from "store/actions/transaction";
import { useDispatch, useSelector } from "react-redux";
import { ListCard, ListCardField, ListCards } from "components";
import useCompactLayout from "hooks/useCompactLayout";

import { setOrderDetail } from "store/actions/restaurant";
import { CSVLink } from "react-csv";


const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  actions: {
    justifyContent: "flex-end",
  },
  textLink: {
    textDecoration: "underline",
  },
  totalRow: {
    backgroundColor: "#f5f5f5",
  },
}));

const TimesheetsTable = (props) => {
  // businessTimezone prop allows specifying the timezone for the business/restaurant
  // Defaults to user's local timezone if not specified
  const { className, timesheets, updateIds,  ...rest } = props;
  
  // Fallback to user's local timezone if businessTimezone is not provided or invalid
  // This ensures consistent timezone display across all timesheet data
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const classes = useStyles();
  const dispatch = useDispatch();
  const isCompact = useCompactLayout();
  const history = useHistory();

  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [keyword, setKeyword] = useState("");

  const updateTransactionDetail = (transaction) => dispatch(setTransactionDetail(transaction));
  const updateTransactionIds = (ids) => dispatch(setTransactionIds(ids));
  const showOrderDetail = (order) => dispatch(setOrderDetail(order));
  const setPage = (page) => dispatch(setTransactionPage(page));
  const page = useSelector((state) => state.transaction.page);

  const handleSelectAll = (event) => {
    let selectedRestaurants;

    if (event.target.checked) {
      selectedRestaurants = timesheets.map((order) => order.id);
    } else {
      selectedRestaurants = [];
    }

    setSelectedTransactions(selectedRestaurants);
  };

  // const handleSelectOneOld = (event, transactionId) => {
  //   const selectedIndex = selectedTransactions.indexOf(transactionId);
  //   let newSelectedTransactions = [];

  //   if (selectedIndex === -1) {
  //     newSelectedTransactions = newSelectedTransactions.concat(selectedTransactions, transactionId);
  //   } else if (selectedIndex === 0) {
  //     newSelectedTransactions = newSelectedTransactions.concat(selectedTransactions.slice(1));
  //   } else if (selectedIndex === selectedTransactions.length - 1) {
  //     newSelectedTransactions = newSelectedTransactions.concat(selectedTransactions.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelectedTransactions = newSelectedTransactions.concat(
  //       selectedTransactions.slice(0, selectedIndex),
  //       selectedTransactions.slice(selectedIndex + 1)
  //     );
  //   }

  //   setSelectedTransactions(newSelectedTransactions);
  //   updateIds(newSelectedTransactions);
  // };

  const handleSelectOne = (event, id) => {
    setSelectedTransactions([id]);
    updateIds([id]);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const getTimeString = (date) => {
    if (!date) {
      return "";
    }

    // check date is object
    let momentDate;
    if (typeof date === "object" && "_seconds" in date) {
      momentDate = moment.unix(date._seconds);
    } else {
      momentDate = moment.unix(Number(date));
    }
    
    // Convert to business timezone and format
    return momentDate.tz(timezone).format("DD/MM/YYYY HH:mm:ss z");
  };

  const filtertimesheets = timesheets
    ? timesheets.filter((timesheet) => {
        if (keyword === "") {
          return true;
        }
        const lowcaseKey = keyword.toLocaleLowerCase();
        if (timesheet.id.toLowerCase().includes(lowcaseKey)) {
          return true;
        }
        if (timesheet.firstName.toLowerCase().includes(lowcaseKey)) {
          return true;
        }

        if (timesheet.lastName.toLowerCase().includes(lowcaseKey)) {
          return true;
        }

        return false;
      })
    : [];

  const csvData = () => {
    let data = [];
    data.push(["Name", "Checkin", "Checkout", "Hours"]);

    timesheets.forEach((item, index) => {
      const name = `${item.firstName} ${item.lastName}`;

      if (item.hours) {
        if (!item.timesheetVersion) {
          let checkoutTime = "";
          if (item && item.checkoutTime && typeof item.checkoutTime === "object" && "_seconds" in item.checkoutTime) {
            checkoutTime = moment.unix(item.checkoutTime._seconds).tz(timezone).format("DD/MM/YYYY HH:mm:ss z");
          } else if (item && item.checkoutTime && typeof item.checkoutTime === "number") {
            checkoutTime = moment.unix(item.checkoutTime).tz(timezone).format("DD/MM/YYYY HH:mm:ss z");
          }

          let checkinTime = "";
          if (item && item.checkinTime && typeof item.checkinTime === "object" && "_seconds" in item.checkinTime) {
            checkinTime = moment.unix(item.checkinTime._seconds).tz(timezone).format("DD/MM/YYYY HH:mm:ss z");
          } else if (item.checkinTime && typeof item.checkinTime === "number") {
            checkinTime = moment.unix(item.checkinTime).tz(timezone).format("DD/MM/YYYY HH:mm:ss z");
          }
         
          data.push([name, checkinTime, checkoutTime, Number(item.hours)]);
        } else  {
          const checkinTime = moment.unix(item.checkinTime).tz(timezone).format("DD/MM/YYYY HH:mm:ss z");

          const checkoutTime = moment.unix(item.checkoutTime).tz(timezone).format("DD/MM/YYYY HH:mm:ss z");

          data.push([name, checkinTime, checkoutTime, Number(item.hours)]);
        }
      }
    });
    //console.log('data', data);
    return data;
  };

  const itemRow = (timesheet) => {
    // console.log("timesheet", timesheet);
    return (
      <TableRow
        className={classes.tableRow}
        hover
        key={timesheet.id}
        selected={selectedTransactions.indexOf(timesheet.id) !== -1}
      >
        <TableCell padding="checkbox">
          <Checkbox
            checked={selectedTransactions.indexOf(timesheet.id) !== -1}
            color="primary"
            onChange={(event) => handleSelectOne(event, timesheet.id)}
            value="true"
          />
        </TableCell>

        <TableCell>{`${timesheet.firstName} ${timesheet.lastName}`}</TableCell>

        <TableCell>{timesheet.type}</TableCell>
        <TableCell>{getTimeString(timesheet.recordTime)}</TableCell>
        <TableCell>{timesheet.hours}</TableCell>
      </TableRow>
    );
  };

  const totalRow = (timesheet) => {
    return (
      <TableRow className={classes.totalRow} hover key={timesheet.id}>
        <TableCell colSpan="2">{`${timesheet.name}`}</TableCell>

        <TableCell colSpan="2">{timesheet.day}</TableCell>

        <TableCell>{timesheet.total}</TableCell>
      </TableRow>
    );
  };

  // One slice, shared by both layouts, so page state survives a resize.
  const pagedTimesheets = filtertimesheets.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // A clock-in/out entry renders as a selectable card; a daily total renders as
  // a summary card without a checkbox, mirroring itemRow/totalRow.
  const itemCard = (timesheet) => (
    <ListCard
      key={timesheet.id}
      data-testid="timesheet-card"
      header={
        <>
          <Checkbox
            checked={selectedTransactions.indexOf(timesheet.id) !== -1}
            color="primary"
            onChange={(event) => handleSelectOne(event, timesheet.id)}
            size="small"
            inputProps={{ "aria-label": `select timesheet entry for ${timesheet.firstName} ${timesheet.lastName}` }}
          />
          <Typography variant="body1">{`${timesheet.firstName} ${timesheet.lastName}`}</Typography>
        </>
      }
    >
      <ListCardField label="Type" value={timesheet.type} />
      <ListCardField label="Clock time" value={getTimeString(timesheet.recordTime)} />
      <ListCardField label="Hours" value={timesheet.hours} />
    </ListCard>
  );

  const totalCard = (timesheet) => (
    <ListCard
      key={timesheet.id}
      data-testid="timesheet-total-card"
      className={classes.totalRow}
      header={<Typography variant="body1">{timesheet.name}</Typography>}
    >
      <ListCardField label="Day" value={timesheet.day} />
      <ListCardField label="Total" value={timesheet.total} />
    </ListCard>
  );

  const renderCards = () => (
    <ListCards count={filtertimesheets.length} noun="entry" empty="No timesheet entries to show.">
      {pagedTimesheets.map((timesheet) =>
        timesheet.type === "checkout" || timesheet.type === "checkin"
          ? itemCard(timesheet)
          : totalCard(timesheet)
      )}
    </ListCards>
  );

  return (
    <Grid md={12} xl={12} xs={12}>
      {timesheets && timesheets.length > 0 ? (
        <CSVLink filename={"timesheets.csv"} data={csvData()}>
          <Button color="primary" variant="contained">
            Download CSV
          </Button>
        </CSVLink>
      ) : null}
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {isCompact ? renderCards() : (
          <div className={classes.inner}>
            <TextField
              placeholder="Search..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              variant="outlined"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: keyword && (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setKeyword('')} edge="end">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      {/* <Checkbox
                      checked={selectedTransactions.length === transactions.length}
                      color="primary"
                      indeterminate={
                        selectedTransactions.length > 0 &&
                        selectedTransactions.length < transactions.length
                      }
                      onChange={handleSelectAll}
                    /> */}
                    </TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Clock Time</TableCell>
                    <TableCell>Hours</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pagedTimesheets.map((timesheet) => {
                      if (timesheet.type === "checkout" || timesheet.type === "checkin") {
                        return itemRow(timesheet);
                      } else {
                        return totalRow(timesheet);
                      }
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          )}
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={filtertimesheets.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[20, 50, 100]}
          />
        </CardActions>
      </Card>
    </Grid>
  );
};

TimesheetsTable.propTypes = {
  className: PropTypes.string,
  timesheets: PropTypes.array.isRequired,
  businessTimezone: PropTypes.string,
};

export default TimesheetsTable;
